<template>
  <div class="flex items-center justify-center" :class="[small && 'h-4 w-4 gap-[0.167rem]', !small && 'h-6 w-6 gap-1']">
    <div
      v-for="i in 3"
      :key="i"
      :class="[$style.dot, small && 'h-0.5 w-0.5', !small && 'h-1 w-1']"
      :style="{ '--delay': `${i * 150}ms` }"
    />
  </div>
</template>

<script setup lang="ts">
import { defineComponent } from 'vue'

defineProps<{
  small?: boolean
}>()

defineComponent({ name: 'UiDotLoader' })
</script>

<style lang="scss" module>
.dot {
  background-color: theme('colors.gray.30');
  border-radius: 50%;
  animation: dotLoader 1400ms cubic-bezier(0.455, 0.03, 0.515, 0.955) var(--delay) infinite;
}

@keyframes dotLoader {
  0% {
    background-color: theme('colors.gray.30');
  }
  40% {
    background-color: theme('colors.gray.60');
  }
  70% {
    background-color: theme('colors.gray.30');
  }
}
</style>
